import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class ChannelPricingTableHoverService extends Service {
  @tracked hoveredColumnId?: string | null = null;
}

declare module '@ember/service' {
  interface Registry {
    'channel-pricing/table-hover': ChannelPricingTableHoverService;
  }
}
